export default __webpack_public_path__ + "static/park-pedregal-amenidades-02-gym-d52ce57bedbc7dc617f10c2f8be1a869.jpg";